export const STORAGE_KEY = 'sb-user-config';

// TODO: Remove legacy key migration once all active users have been migrated - SHB-19574
export const LEGACY_KEY_MAP: Record<string, string> = {
  'sb-schedule-sidebar-toggle': 'scheduleSidebarOpen',
  'sb-dashboard-sidebar-minimized': 'dashboardSidebarOpen',
  devToolsOpen: 'devToolsOpen',
  'insights-page-promo-dismissed': 'insightsPromoDismissed',
  'sb-self-onboarding-checklist-dismissed': 'onboardingChecklistDismissed',
  employeeListGroupBy: 'employeeListGroupBy',
};

// TODO: Remove legacy key migration once all active users have been migrated - SHB-19574
/** Keys where the legacy value has inverted semantics (minimized → open) */
export const INVERTED_LEGACY_KEYS = new Set<string>(['sb-dashboard-sidebar-minimized']);
